// extracted by mini-css-extract-plugin
module.exports = {"primaryAnnouncement":"PrimaryAnnouncement_primaryAnnouncement__RgWbJ","primaryAnnouncementCopy":"PrimaryAnnouncement_primaryAnnouncementCopy__pgOLq"};